import React,{ useState } from 'react';
import './App.css';
import Header from './Header/Header.js';
import Content from './Content/Content.js';
import Footer from './Footer/Footer.js';

function App(){
  //const [signedIn, setSignedIn] = useState(false);
  const [userInfo,setUserInfo] = useState({
    signedIn:false,
    userToken:'',
    userName:'',
    userID:'',
    email:'',
    role:'anon',
    timeSlot:false,
    participated:[],
    group:''
  })

  function handleChange(newUserInfo) {
      //setSignedIn(newSignedInState);
      setUserInfo(newUserInfo);
    }
  return(
    <div>
      <Header userInfo={userInfo} onChange={handleChange}/>
      <Content userInfo={userInfo} onChange={handleChange}/>
      <Footer/>
    </div>
  )
}

export default App
